document.addEventListener('DOMContentLoaded', function () {
  var favoriteSections = document.querySelectorAll('[data-capucinne-favorites]');

  favoriteSections.forEach(function (section) {
    var buttons = section.querySelectorAll('[data-favorites-filter]');
    var cards = section.querySelectorAll('.cap-home-product-card');

    if (!buttons.length || !cards.length) {
      return;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.getAttribute('data-favorites-filter');

        buttons.forEach(function (item) {
          var isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        cards.forEach(function (card) {
          var category = card.getAttribute('data-category');
          card.hidden = filter !== 'all' && category !== filter;
        });
      });
    });
  });

  var announcement = document.querySelector('[data-capucinne-announcement]');

  // Rotate the announcement slides. Each block in the bar is a stacked slide;
  // only `.is-active` is shown. Cycles on the merchant's speed (data-announcement-
  // speed) when autoplay is on, there is more than one slide, and the visitor does
  // not prefer reduced motion. Pauses on hover/focus so links stay readable.
  if (announcement) {
    var annTrack = announcement.querySelector('[data-capucinne-announcement-track]');
    var slides = annTrack ? annTrack.querySelectorAll('[data-capucinne-announcement-slide]') : [];
    var autoplay = announcement.getAttribute('data-announcement-autoplay') !== 'false';
    var speed = parseFloat(announcement.getAttribute('data-announcement-speed'));
    if (!isFinite(speed) || speed <= 0) speed = 5;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length > 1 && autoplay && !reduceMotion) {
      var current = 0;
      var intervalMs = Math.max(2, speed) * 1000;
      var timer = null;

      var advance = function () {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
        slides[current].removeAttribute('aria-hidden');
      };
      var start = function () { if (!timer) timer = window.setInterval(advance, intervalMs); };
      var stop = function () { if (timer) { window.clearInterval(timer); timer = null; } };

      announcement._capRotateStop = stop;
      announcement.addEventListener('mouseenter', stop);
      announcement.addEventListener('mouseleave', start);
      announcement.addEventListener('focusin', stop);
      announcement.addEventListener('focusout', start);
      start();
    }
  }

  // NORMAL SEARCH BAR (merchant 2026-09-01). The header bar IS the classic
  // catalog search: typing + Enter submits natively to /search. The sparkle
  // magnifier is decorative (merchant 2026-09-15: no click behaviour at all);
  // the AI lives on the consultant page, reached via Start Consultation.

  var searchForms = document.querySelectorAll('[data-capucinne-search-form]');

  searchForms.forEach(function (form) {
    var input = form.querySelector('[data-capucinne-search-input]');
    var clearButton = form.querySelector('[data-capucinne-search-clear]');
    var voiceButton = form.querySelector('[data-capucinne-voice-trigger]');

    if (!input) {
      return;
    }

    form.addEventListener('click', function (event) {
      if (event.target === form || event.target.classList.contains('capucinne-site-header__search-divider')) {
        input.focus();
      }
    });

    form.addEventListener('submit', function (event) {
      if (!input.value.trim()) {
        event.preventDefault();
        input.focus();
      }
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        if (input.value) {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        input.focus();
      });
    }

    if (voiceButton) {
      voiceButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        // Dictation fills the plain search field; the shopper reviews the text
        // and presses Enter (or taps the keyboard's search key) to run it.
        startVoiceInput(input, voiceButton, function (text) {
          if (!text) return;

          input.value = text;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
    }
  });

  // AI SEARCH INTRO (merchant 2026-09-14/15): a "NEW" badge sits on the Start
  // Consultation button (desktop) / the sparkle magnifier of the search bar
  // (phones) permanently (CSS), and once per browser session a small callout
  // under it says "This is our new AI search! Test it and let us know if it
  // works." It shows ~1.2 s after load, closes itself after 10 s (merchant:
  // "make the balloon auto close on both desktop and mobile after 10 seconds"),
  // on the X, on Escape, or when the shopper focuses the search field; tapping
  // it goes to the consultant page, like its anchor. Never on the consultant
  // page (the chat is already open there).
  (function initAiSearchIntro() {
    // Everything is looked up fresh and handled by delegation: the header can
    // be cloned/re-rendered after load (sticky header, section rerender), which
    // would strand listeners bound to the original nodes.
    var intros = function () { return Array.prototype.slice.call(document.querySelectorAll('[data-cap-ai-intro]')); };
    if (!intros().length) return;

    // The NEW pill and the callout's arrow are positioned purely in CSS
    // (--cap-ai-anchor-x / --cap-ai-anchor-right on the consult wrap and the
    // phone search form, capucinne-redesign.css). They used to be measured
    // here after load, which moved the pill a few pixels on a first visit
    // (merchant 2026-09-16: "it moves a little left and right for one moment") -
    // never measure and set them from script again.
    var SHOW_DELAY_MS = 1200;
    var AUTO_CLOSE_MS = 10000;
    var KEY = 'capucinneAiIntroShown';
    var onConsultantPage = !!document.querySelector('.cap-ai-consultant.is-page-fit') || /\/pages\/capucinne-consultant(?:\/|$)/.test(location.pathname);
    var already = false;
    try { already = sessionStorage.getItem(KEY) === '1'; } catch (error) { already = false; }
    if (onConsultantPage || already) return;

    var closeTimer = null;
    var anyOpen = function () { return intros().some(function (el) { return !el.hidden; }); };
    var markShown = function () { try { sessionStorage.setItem(KEY, '1'); } catch (error) { /* private mode */ } };
    var formOf = function (el) { return el.closest('[data-cap-ai-anchor]'); }; // the positioned container (consult wrap / phone form)
    var hideAll = function () {
      if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
      intros().forEach(function (el) {
        el.classList.remove('is-visible');
        var form = formOf(el);
        window.setTimeout(function () { el.hidden = true; if (form) form.classList.remove('has-ai-intro'); }, 260);
      });
      markShown();
    };
    var showAll = function () {
      intros().forEach(function (el) {
        el.hidden = false;
        var form = formOf(el);
        if (form) form.classList.add('has-ai-intro'); // lifts the form above the nav row (CSS)
        // next frame so the fade-in transition runs
        window.requestAnimationFrame(function () { el.classList.add('is-visible'); });
      });
      closeTimer = window.setTimeout(hideAll, AUTO_CLOSE_MS);
      try { document.dispatchEvent(new CustomEvent('capucinne:ai-intro', { detail: { state: 'shown' } })); } catch (error) { /* ignore */ }
    };

    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var closeButton = target.closest('[data-cap-ai-intro-close]');
      if (closeButton) { event.preventDefault(); hideAll(); return; }
      var openButton = target.closest('[data-cap-ai-intro-open]');
      if (openButton) {
        event.preventDefault();
        var box = openButton.closest('[data-cap-ai-anchor]');
        var go = box ? box.getAttribute('data-cap-ai-anchor-href') : '';
        hideAll();
        // the callout goes where its anchor goes: the consultant page
        if (go) { try { window.location.assign(go); } catch (error) { /* ignore */ } return; }
        var form = box && box.matches('[data-capucinne-search-form]') ? box : null;
        var input = form ? form.querySelector('[data-capucinne-search-input]') : null;
        if (input) input.focus();
        return;
      }
      // the consult button (desktop) / the sparkle magnifier link (phones) itself
      // starts the AI - the hint has done its job (and the session is marked
      // before the navigation, so the callout never comes back on the next page)
      if (target.closest('.capucinne-site-header__consult, .capucinne-site-header__search-submit--ai') && anyOpen()) hideAll();
    });
    document.addEventListener('focusin', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (target && target.matches('[data-capucinne-search-input]') && anyOpen()) hideAll();
    });
    document.addEventListener('keydown', function (event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && anyOpen()) hideAll();
    });

    window.setTimeout(showAll, SHOW_DELAY_MS);
  })();

  function startVoiceInput(input, button, onFinal) {
    var Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!Recognition) {
      if (input) {
        input.focus();
        input.placeholder = 'Voice input is not supported in this browser';
      }

      button.classList.add('is-unsupported');
      window.setTimeout(function () {
        button.classList.remove('is-unsupported');
      }, 1400);
      return;
    }

    if (button._capRecognition) {
      button._capRecognition.stop();
      return;
    }

    var recognition = new Recognition();
    var submitted = false;

    recognition.lang = (function (lang) {
      // Region-qualify a bare tag ('en'): WebKit's recognizer wants one.
      if (!lang) return 'en-US';
      if (lang.indexOf('-') !== -1) return lang;
      var device = String((navigator && navigator.language) || '');
      if (device.toLowerCase().indexOf(lang.toLowerCase() + '-') === 0) return device;
      return lang === 'en' ? 'en-US' : lang;
    })(document.documentElement.lang || '');
    recognition.interimResults = true;
    recognition.continuous = false;
    button._capRecognition = recognition;
    button.classList.add('is-listening');
    button.setAttribute('aria-label', 'Listening');

    recognition.onresult = function (event) {
      var transcript = '';
      var isFinal = false;

      for (var index = event.resultIndex; index < event.results.length; index += 1) {
        transcript += event.results[index][0].transcript;
        if (event.results[index].isFinal) isFinal = true;
      }

      transcript = transcript.trim();
      if (input && transcript) input.value = transcript;

      if (isFinal && transcript && !submitted) {
        submitted = true;
        onFinal(transcript);
      }
    };

    recognition.onerror = function (event) {
      var code = event && event.error ? String(event.error) : '';
      if ((code === 'not-allowed' || code === 'service-not-allowed') && input) {
        // Blocked microphone: say so in the field instead of a silent stop.
        input.placeholder = 'Microphone blocked - allow it in your browser settings, or use the keyboard dictation key';
      }
      stopVoiceInput(button);
    };

    recognition.onend = function () {
      stopVoiceInput(button);
    };

    recognition.start();
  }

  function stopVoiceInput(button) {
    if (!button) return;

    button._capRecognition = null;
    button.classList.remove('is-listening');
    button.setAttribute('aria-label', button.classList.contains('capucinne-site-header__search-voice') ? 'Speak to search' : 'Speak your search');
  }
});
